import { Box, Icon } from '@quintoandar-tokko/jopijs';
import RowName from '../../DashboardOverview/RowCards/components/RowName';
import ProgressBar from '../../DashboardOverview/RowCards/components/ProgressBar';
import ItemCount from '../../DashboardOverview/RowCards/components/ItemCount';
import PercentageValue from '../../DashboardOverview/RowCards/components/PercentageValue';
import styles from './closedLeads.module.scss';
import WithoutCategoryTag from '../../DashboardOverview/RowCards/components/WithoutCategoryTag';
import { CLOSED_LEADS_QUALIFICATIONS } from '../../constants';

const validQualifications = Object.values(CLOSED_LEADS_QUALIFICATIONS);
const iconsMap = {
  [CLOSED_LEADS_QUALIFICATIONS.POSITIVE]: 'icon-positivo',
  [CLOSED_LEADS_QUALIFICATIONS.NEGATIVE]: 'icon-negativo',
  [CLOSED_LEADS_QUALIFICATIONS.NEUTRAL]: 'icon-neutro',
};

export default function ClosedLeadsRow({
  name,
  percentage,
  count,
  qualification,
  ...rest
}) {
  const renderRowName = () => {
    if (!validQualifications.includes(qualification))
      return <RowName text={name} />;

    if (qualification === CLOSED_LEADS_QUALIFICATIONS.WITHOUT_IT)
      return <WithoutCategoryTag text={name} />;

    return (
      <Box className={styles.qualificationRowWrapper}>
        <Icon icon={iconsMap[qualification]} />
        <RowName text={name} />
      </Box>
    );
  };
  return (
    <Box className={styles.row} {...rest}>
      <Box className={styles.rowInnerWrapper}>
        {renderRowName()}
        <ProgressBar percentage={percentage} />
        <ItemCount icon="icon-contactos" value={count} />
        <PercentageValue percentage={percentage} />
      </Box>
    </Box>
  );
}
